/**
 * Modernizr test for checking if sessionStorage is supported.
 *
 * https://github.com/Modernizr/Modernizr/blob/d31f4a000d4cf9cc393e018ab13d29c00775f0e0/feature-detects/storage/sessionstorage.js
 */
export function sessionStorageSupported(): boolean {
	const value = 'testSessionStorage';

	try {
		sessionStorage.setItem(value, value);
		sessionStorage.removeItem(value);
		return true;
	} catch (e) {
		return false;
	}
}

/**
 * Modernizr test for checking if localStorage is supported.
 *
 * https://github.com/Modernizr/Modernizr/blob/e2c27dcd32d6185846ce3c6c83d7634cfa402d19/feature-detects/storage/localstorage.js
 */
export function localStorageSupported(): boolean {
	const value = 'testLocalStorage';

	try {
		localStorage.setItem(value, value);
		localStorage.removeItem(value);
		return true;
	} catch (e) {
		return false;
	}
}
